import { render } from "./phoneinput.vue?vue&type=template&id=32b45fda"
import script from "./phoneinput.vue?vue&type=script&lang=js"
export * from "./phoneinput.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__